export default __webpack_public_path__ + "static/media/1956.a45b5068.png";